var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ico",
    d: "M13.75 0V3.75C13.75 4.45312 14.2969 5 15 5H18.75V13.75C18.75 15.1562 17.6172 16.25 16.25 16.25H7.5C6.09375 16.25 5 15.1562 5 13.75V2.5C5 1.13281 6.09375 0 7.5 0H13.75ZM18.75 3.75H16.9531H16.25H15V2.5V1.79688V0L16.25 1.25L17.5 2.5L18.75 3.75ZM3.125 4.6875V14.6875C3.125 16.6016 4.64844 18.125 6.5625 18.125H14.0625C14.5703 18.125 15 18.5547 15 19.0625C15 19.6094 14.5703 20 14.0625 20H6.5625C3.59375 20 1.25 17.6562 1.25 14.6875V4.6875C1.25 4.17969 1.64062 3.75 2.1875 3.75C2.69531 3.75 3.125 4.17969 3.125 4.6875Z",
    fill: "url(#paint0_linear_3390_1434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ico_2",
    d: "M13.75 0V3.75C13.75 4.45312 14.2969 5 15 5H18.75V13.75C18.75 15.1562 17.6172 16.25 16.25 16.25H7.5C6.09375 16.25 5 15.1562 5 13.75V2.5C5 1.13281 6.09375 0 7.5 0H13.75Z",
    fill: "#E6E8F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3390_1434",
    x1: 1.25,
    y1: 2,
    x2: 18.0331,
    y2: 16.2533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3677D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.179b7c49381b9c3192b29353aa7aa26b.svg";
export { ForwardRef as ReactComponent };